import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  input,
  computed,
  afterNextRender,
  ElementRef,
  ViewChild,
  inject,
  HostListener,
} from '@angular/core';
import { Image, ImageComponent, ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { YoutubeComponent } from '../youtube/youtube.component';
import { StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { SafePipe } from '@teamfoster/sdk/text-utility';
import { DOCUMENT } from '@angular/common';
import { ContentBlock } from 'src/app/content-blocks/models';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: true,
  styleUrls: ['./header.component.scss'],
  imports: [ImageComponent, YoutubeComponent, ResizeHtmlImagesPipe, StripEmbedPipe, SafePipe],
})
export class HeaderComponent {
  title = input<string>();
  subTitle = input<string | null>();
  intro = input<string | null>();
  image = input<Image | null>();

  theme = input<'accent' | 'secondary'>('accent');

  cleanIntro = computed(() => {
    const intro = this.intro();

    // remove all <p><br></p> from intro
    return intro?.replace(/<p><br><\/p>/g, '');
  });
}
